module.exports = __webpack_public_path__ + "img/frame (65).d0016aae.jpg";